export enum InterruptSource {
  Live = 'live',
  Scheduled = 'scheduled'
}
